(() => {
  'use strict';
  if (window.__zavoLuxuryHeroFxLoaded) return;
  window.__zavoLuxuryHeroFxLoaded = true;

  const init = (root) => {
    if (!root || root.dataset.zlhReady === 'true') return;
    root.dataset.zlhReady = 'true';

    const canHover = matchMedia('(hover:hover) and (pointer:fine)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 749px)');
    const allowMobile = root.dataset.zlhEffectsMobile === 'true';
    const parallax = root.dataset.zlhParallax === 'true';
    const followGlow = root.dataset.zlhGlowFollow === 'true';
    const strength = Math.max(0, Number(root.dataset.zlhParallaxStrength) || 7);

    if (reduced.matches || (!canHover.matches && !(mobile.matches && allowMobile)) || (!parallax && !followGlow)) return;

    let raf = 0;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    const draw = () => {
      currentX += (targetX - currentX) * .075;
      currentY += (targetY - currentY) * .075;
      if (parallax) {
        root.style.setProperty('--zlh-px', `${currentX * strength}px`);
        root.style.setProperty('--zlh-py', `${currentY * strength}px`);
      }
      if (followGlow) {
        root.style.setProperty('--zlh-glow-x', `${50 + currentX * 34}%`);
        root.style.setProperty('--zlh-glow-y', `${50 + currentY * 28}%`);
      }
      raf = requestAnimationFrame(draw);
    };

    root.addEventListener('pointermove', (event) => {
      if (event.pointerType && event.pointerType !== 'mouse' && !allowMobile) return;
      const box = root.getBoundingClientRect();
      targetX = Math.max(-1, Math.min(1, ((event.clientX - box.left) / box.width - .5) * 2));
      targetY = Math.max(-1, Math.min(1, ((event.clientY - box.top) / box.height - .5) * 2));
    }, {passive:true});

    root.addEventListener('pointerleave', () => { targetX = 0; targetY = 0; }, {passive:true});
    raf = requestAnimationFrame(draw);

    root._zlhDestroy = () => cancelAnimationFrame(raf);
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-zlh-interactive]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelector('[data-zlh-interactive]')?._zlhDestroy?.());
})();
